import React from 'react'
import { ReviewModel } from '../../typings/reviews'
import FiveStars from '../../components/five-stars';
import { AppConstants } from '../../utils/app-constants';
import { Breakpoints, Link, OpenInLayer, styled, TextCustom, useIsMobile } from '@vw-marketing/us-components';
import { reviewsLinkStyle } from './helpers';

interface ModelReviews {
    reviews?: ReviewModel;
    onOpenReviews?: () => void;
}
const StyledModelReviewsContainer = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  column-gap: 8px;
  a {
    cursor: pointer;
  }
`
const ModelReviews = ({reviews, onOpenReviews}) => {
    const {averageRating} = reviews;
    const reviewsLabel = `${reviews.averageRating.toFixed(1)} | ${reviews.page.totalElements} reviews `
    const isMobile =  useIsMobile(Breakpoints.b960);
  return (
    <StyledModelReviewsContainer className="reviews-wrapper">
        <FiveStars
          percent={((averageRating || 0) / 5) * 100}
          starSize={isMobile ? "14px": "20px" }
          starColor={"#001E50"}
          background={AppConstants.StarBackground as string}
        />
        <Link onClick={onOpenReviews} isInline>
            <TextCustom {...reviewsLinkStyle}>
            {reviewsLabel}
            </TextCustom>
            <OpenInLayer variant="small"/>
        </Link>
    </StyledModelReviewsContainer>
  )
}

export default ModelReviews